import React, { useState, useEffect } from "react";
import { fetchPlanOptionsAndPlans, fetchSubOptions } from "../../medPracapi";
import Form from "react-bootstrap/Form";
import Spinner from "react-bootstrap/Spinner";

function PlanOptionSelector({ schemeCode, onPlanOptionSelect }) {
  const [planOptions, setPlanOptions] = useState([]);
  const [selectedPlanOptionId, setSelectedPlanOptionId] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!schemeCode) return;

    const loadPlanOptions = async () => {
      setLoading(true);
      try {
        const data = await fetchPlanOptionsAndPlans(schemeCode);
        // Add a unique identifier to each option for tracking
        const optionsWithIds = (data || []).map((item, index) => ({
          ...item,
          id: `${item.option.code}-${item.plan.code}`
        }));
        setPlanOptions(optionsWithIds);
      } catch (error) {
        console.error("Error loading plan options:", error);
      } finally {
        setLoading(false);
      }
    };

    loadPlanOptions();
    // Reset selection when scheme changes
    setSelectedPlanOptionId("");
  }, [schemeCode]);

  const handlePlanOptionSelect = async (e) => {
    const selectedId = e.target.value;
    if (!selectedId) {
      setSelectedPlanOptionId("");
      return;
    }
  
    const selectedItem = planOptions.find(item => item.id === selectedId);
    if (!selectedItem) return;
  
    setSelectedPlanOptionId(selectedId);
  
    try {
      const subOptions = await fetchSubOptions(selectedItem.option.code);
  
      const firstSubOption = subOptions.length > 0 ? subOptions[0].planSubOption : null;
      const firstDataTransmission = firstSubOption?.dataTransmissions?.[0];
  
      onPlanOptionSelect({
        patientMedicalAidOption: selectedItem.option.option,
        patientMedicalAidOptionCode: selectedItem.option.code,
        patientMedicalAidPlan: selectedItem.plan.plan,
        patientMedicalAidPlanCode: selectedItem.plan.code,
        patientMediKreditPlanNumber03: firstDataTransmission?.mk03Id || "",
        patientMediKreditPlanNumber04: firstDataTransmission?.mk04Id || "",
        patientMediKreditPlanNumber06: firstDataTransmission?.mk06Id || "",
      });
  
      console.log("Selected Plan Option:", selectedItem);
      console.log("Selected Plan:", selectedItem.plan.plan);
      console.log("Selected Plan Option Code:", selectedItem.option.code);
      console.log("Selected Plan Code:", selectedItem.plan.code);
      console.log("Selected Plan Option:", selectedItem.option.option);
      console.log("Sub Options:", subOptions);
      console.log("Sub Options mk03Id:", firstDataTransmission?.mk03Id);
      console.log("Sub Options mk04Id:", firstDataTransmission?.mk04Id);
      console.log("Sub Options mk06Id:", firstDataTransmission?.mk06Id);
  
    } catch (error) {
      console.error("❌ Error fetching subOptions:", error);
    }
  };
  

  // Sort the options once for display
  const sortedPlanOptions = [...planOptions].sort((a, b) => 
    a.option.option.localeCompare(b.option.option)
  );

  return (
    <Form.Group controlId="formGridPlanOption">
      <Form.Label>Medical Aid Plan</Form.Label>
      {loading ? (
        <Spinner animation="border" size="sm" />
      ) : (
        <Form.Select
          value={selectedPlanOptionId}
          onChange={handlePlanOptionSelect}
        >
          <option value="">Select Plan Option & Plan</option>
          {sortedPlanOptions.length > 0 ? (
            sortedPlanOptions.map((item) => (
              <option key={item.id} value={item.id}>
                {item.option.option} | {item.plan.plan}
              </option>
            ))
          ) : (
            <option disabled>No options available</option>
          )}
        </Form.Select>
      )}
    </Form.Group>
  );
}

export default PlanOptionSelector;